module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Cloud-download-e70f2595a509417fec6c8c1509192d53.svg";